import webUtils from './webUtils';
import _toLower from 'lodash/toLower';
import _replace from 'lodash/replace';
import i18n from 'i18next';

const utils = {
  getParam: (paramName = 'id', params, location) => {
    if (params[paramName]) {
      return params[paramName];
    }
    return new URLSearchParams(location.search).get(paramName);
  },
  getLangPrefix: (
    lang = webUtils.getPathnameLang(window.location.pathname)
  ) => {
    if (!lang || lang === 'en') {
      return '';
    }
    return `/${_replace(_toLower(lang), '_', '-')}`;
  },
  getYceLangPrefix: (
    lang = webUtils.getPathnameLang(window.location.pathname)
  ) => {
    const langPrefix = utils.getLangPrefix(lang);
    return ['/ko', '/zh-cn'].includes(langPrefix) ? '' : langPrefix; // YCE does not support these languages
  },
  addLangPrefix: (url = '') => {
    if (!url) return '';
    const lang = webUtils.getPathnameLang(window.location.pathname);
    if (!lang || lang === 'en') {
      return url;
    }
    if (url.startsWith('http')) {
      return url;
    }
    return utils.getLangPrefix(lang) + url;
  },
  removeLangPrefix: (url = '') => {
    if (!url) return '';
    if (url.startsWith('http')) {
      return url;
    }
    const lang = webUtils.getPathnameLang(window.location.pathname);
    if (!lang) {
      return url;
    }
    const langPrefix = utils.getLangPrefix(lang);
    if (url.startsWith(langPrefix)) {
      return url.slice(langPrefix.length);
    }
    return url;
  },
  removeQueryStrings: (url = '') => {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      console.error('Invalid URL to remove query strings:', url, e);
      return url;
    }
  },
  langToPathPrefix: () =>
    i18n.language === 'en' || !i18n.language
      ? ''
      : utils.getLangPrefix(i18n.language),
};

export default utils;
